module.exports = __webpack_public_path__ + "img/视频.65eccf56.svg";